import { useState, useEffect } from 'react';
import { SxProps } from '@mui/material';
import axios from 'src/utils/axios';
import ImageWithPreview from './image-with-preview';

type Props = {
  uid: string;
  folder: 'idCards' | 'bookBanks';
  filename?: string | null;
  alt?: string;
  sx?: SxProps;
  previewSize?: { width: number; height: number };
  showPreview?: boolean;
  disableRightClick?: boolean;
};

export default function PrivateImage({
  uid,
  folder,
  filename,
  alt = '',
  sx,
  previewSize,
  showPreview = true,
  disableRightClick = false,
}: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let currentUrl: string | null = null;

    const fetchImage = async () => {
      if (!filename) {
        setObjectUrl(null);
        return;
      }
      try {
        const params = new URLSearchParams({
          folder,
          filename: filename ?? '',
        });
        const res = await axios.get(
          `/admin/users/${encodeURIComponent(uid)}/private-file?${params.toString()}`,
          { responseType: 'blob' }
        );

        const url = URL.createObjectURL(res.data);
        // Revoke previous URL before setting a new one to avoid leaks
        if (currentUrl) {
          URL.revokeObjectURL(currentUrl);
        }
        currentUrl = url;
        setObjectUrl(url);
      } catch (e) {
        setObjectUrl(null);
      }
    };

    fetchImage();

    return () => {
      if (currentUrl) {
        URL.revokeObjectURL(currentUrl);
      }
    };
  }, [uid, folder, filename]);

  if (!objectUrl) return <>-</>;

  return (
    <ImageWithPreview
      src={objectUrl}
      alt={alt}
      sx={sx}
      previewSize={previewSize}
      showPreview={showPreview}
      disableRightClick={disableRightClick}
      fileName={filename || undefined}
    />
  );
}
